import { render, staticRenderFns } from "./setting-ap.vue?vue&type=template&id=2ee28cc0&scoped=true"
import script from "./setting-ap.vue?vue&type=script&lang=js"
export * from "./setting-ap.vue?vue&type=script&lang=js"
import style0 from "./setting-ap.vue?vue&type=style&index=0&id=2ee28cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee28cc0",
  null
  
)

export default component.exports